export const BRAND_CONFIG_REQUEST = 'BRAND_CONFIG_REQUEST';
export const BRAND_CONFIG_SUCCESS = 'BRAND_CONFIG_SUCCESS';
export const BRAND_CONFIG_FAILURE = 'BRAND_CONFIG_FAILURE';
